const firebaseDomain = process.env.NODE_ENV === 'development' ?
  `http://localhost:5001/${process.env.REACT_APP_FIREBASE_PROJ_ID}/us-central1/api` :
  `https://${process.env.REACT_APP_WEB_HOST_URI}/api`

export { firebaseDomain }